import { render, staticRenderFns } from "./region.vue?vue&type=template&id=54535f39&scoped=true"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54535f39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54535f39')) {
      api.createRecord('54535f39', component.options)
    } else {
      api.reload('54535f39', component.options)
    }
    module.hot.accept("./region.vue?vue&type=template&id=54535f39&scoped=true", function () {
      api.rerender('54535f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/member/region.vue"
export default component.exports